<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :before-close="handleCancel"
    :destroy-on-close="true"
    width="480px"
  >
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <el-form-item label="项目编号" prop="projectCode">
        <el-input v-model="ruleForm.projectCode" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="ruleForm.projectName"></el-input>
      </el-form-item>
      <el-form-item label="所在区县" prop="areas">
        <el-cascader
          ref="cascaders"
          placeholder="请输入或选择中国区域"
          :props="props"
          v-model="place"
          :options="regionList"
          @change="handleCasChange"
          class="custome-popper-class"
          filterable
          style="width: 100%"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleOk" :loading="loading"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { createProject, updateProjectName } from './service';
import to from 'await-to-js';
export default {
  props: {
    visible: {
      type: Boolean,
    },
    record: {
      type: Object,
    },
    regionList: {
      type: Array,
    },
    projectType: {
      type: Number,
    },
  },
  components: {},
  computed: {
    title () {
      return this.record?.projectId ? "修改项目" : '新建项目'
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.record);
      if (this.record) {
        this.ruleForm.projectCode = this.record.projectCode;
        this.ruleForm.projectName = this.record.projectName;
        this.place = [
          this.record.provinceId
         
        ];
        if (this.record.cityId) {
          this.place.push(this.record.cityId)
        }
        if (this.record.countyId) {
          this.place.push(this.record.countyId)
        }
        this.ruleForm.areas = this.place;
      }
    });
  },

  data() {
    return {
      loading: false,
      rules: {
        projectCode: [
          { required: true, message: '请输入项目编号', trigger: 'blur' },
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        areas: [
          { required: true, message: '清选择所在区县', trigger: 'blur' },
        ],
      },
      ruleForm: {
        projectCode: '',
        projectName: '',
        areas: '',
      },
      place: [],
      props: {
        label: 'regionName',
        value: 'regionId',
        children: 'children',
        checkStrictly: false,
      },
    };
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    async handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const requestMethod = this.record?.projectId
            ? updateProjectName
            : createProject;
          const [err, result] = await to(
            requestMethod({
              type: this.projectType,
              projectCode: this.ruleForm.projectCode,
              projectName: this.ruleForm.projectName,
              provinceId: this.place?.[0],
              cityId: this.place?.[1],
              countyId: this.place?.[2],
              projectId: this.record?.projectId,
              // selectProjectId: this.record?.projectId
            })
          );
          if (!err && result.code == 0) {
            this.$message.success(result?.message);
            this.$emit('close');
            this.$emit('saveBack');
          } else {
            // this.$message.error(result?.message || '操作失败');
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    handleCasChange(val) {
      this.$refs.cascaders.dropDownVisible = false;
      this.ruleForm.areas = val;
      console.log(val);
    },
  },
};
</script>